const Events = {
  fantasyParticipated: 'fantasyParticipated',
  fantasyResigned: 'fantasyResigned',
  fantasyCreateTeamDone: 'fantasyCreateTeamDone',
  fantasyCreateTeamParticipated: 'fantasyCreateTeamParticipated',
  fantasyCreateTeamCreated: 'fantasyCreateTeamCreated',
  fantasyCreateTeamVisible: 'fantasyCreateTeamVisible',
  fantasyCreateTeamHidden: 'fantasyCreateTeamHidden',

  cricketMatchUpdate: 'cricketMatchUpdate',
  cricketMatchBallUpdate: 'cricketMatchBallUpdate'
}

export default Events
